import { downloadExcavationPermitPdf, isExcavationPermit as isExcavationPermitPdf } from "../RoadClosureWorkPermit/excavationPermitPdf";
import React, { useState, useEffect, useRef } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import { IoMdArrowBack } from "react-icons/io";
import useClickOutside from "../useClickOutside";
import jsPDF from "jspdf";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import ColdWorkPermitTemplate from "./ColdWorkPermitTemplate";
import HotWorkPermitTemplate from "../HotWorkPermit/HotWorkPermitTemplate";
import ConfinedSpaceTemplate from "../ConfiedSpaceWorkPermit/ConfinedSpaceTemplate";

function PermitExtensionRequestView({ isSidebarExpanded }) {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [severity, setSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const { permit_id } = useParams();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [selectedRenewalId, setSelectedRenewalId] = useState(null);
  const [actionDesignations, setActionDesignations] = useState([]);
  const [renewalId, setRenewalId] = useState(null);
  const [formData, setFormData] = useState({
    additional_instruction: "",
  });

  const handleSaveRejectClick = async (renewal_id) => {
    if (!reason.trim()) {
      setSeverity("error");
      showSnackbar("Reason is required to reject the permit.");
      return;
    }

    const payload = {
      permit_id: permit_id,
      renewal_id: renewal_id,
      request_type: "Extension",
      reason: reason.trim(),
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        throw new Error("Authorization key not found");
      }

      const response = await axios.post(
        `${API_URL}/api/reject_permit`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit rejected successfully.");
        await fetchData(page, itemsPerPage);
        closePopup();
      } else {
        throw new Error(response.data.message || "Failed to reject permit.");
      }
    } catch (error) {
      console.error("Error rejecting permit:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          "An error occurred while rejecting the permit."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleRejectClick = (renewal_id) => {
    setIsPopupOpen(true);
    setIsActionPopupOpen(false);
    setRenewalId(renewal_id);
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setReason("");
    setRenewalId(null);
  };

  const formatDateTime = (dateString) => {
    if (!dateString || dateString === "NA") return "N/A";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";

      const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC",
      });

      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const year = date.getUTCFullYear();

      const dateStr = `${day}/${month}/${year}`;

      return `${dateStr}, ${time}`;
    } catch (error) {
      return "N/A";
    }
  };

  const handleBack = () => {
    window.history.back();
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const fetchData = async (currentPage, itemsPerPage) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_permit_renewal`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          permit_id: permit_id,
        },
      });

      setDesignations(response.data);
      setTotalItems(response.data.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  const fetchRenewalData = async (renewalId) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_permit_renewal`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          renewal_id: renewalId,
        },
      });

      console.log("response.data", response.data);
      setActionDesignations(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching renewal data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, itemsPerPage);
  }, [page, itemsPerPage]);

  useEffect(() => {
    if (isActionPopupOpen && selectedRenewalId) {
      fetchRenewalData(selectedRenewalId);
    }
  }, [isActionPopupOpen, selectedRenewalId]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleCloseButtonClick = () => {
    setChecked(false);
    setSelectedRows([]);
  };

  const handleRefresh = () => {
    fetchData(page, itemsPerPage);
    setSearchInput("");
  };

  const closePopups = () => {
    setIsSortPopup(false);
  };

  const handleClosepopup = () => {
    setIsActionPopupOpen(false);
    setSelectedRenewalId(null);
    setActionDesignations([]);
    setFormData({ additional_instruction: "" });
  };

  const handleExtensionIssuClick = async (renewal_id) => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        console.error("Authorization key not found");
        return;
      }

      const response = await axios.put(
        `${API_URL}/api/v2/issuer/final_issue`,
        { renewal_id, request_type: "extension" },
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 200) {
        console.log(response.data.message);
        setSeverity("success");
        showSnackbar("Extension Work permit Issued successfully!");
        await fetchData(page, itemsPerPage);
        setTimeout(() => {
          navigate(`/cold-work-permit?tab=Issued`);
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving department:", error.message);
      setSeverity("error");
      showSnackbar("An error occurred while issuing the permit.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleActionButton = async (renewalId) => {
    try {
      console.log(`Clicked on designation ID: ${renewalId}`);
      setSelectedRenewalId(renewalId);
      setIsActionPopupOpen(true);
      await fetchRenewalData(renewalId);
    } catch (error) {
      console.error("Error handling action button:", error.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleExtensionReason = async (id) => {
    const payload = {
      permit_id: permit_id,
      renewal_id: id,
      additional_instruction: formData.additional_instruction,
      request_type: "extension",
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.put(
        `${API_URL}/api/v2/issuer/submit_for_review`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Extension Permit Approved successfully.");
        await fetchData(page, itemsPerPage);
        setTimeout(() => {
          navigate(`/cold-work-permit?tab=Issued`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to renew permit.");
      }
    } catch (error) {
      console.error("Error renewing permit:", error);
      setSeverity("error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while renewing the permit.";
      showSnackbar(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFireAndSafetyExtension = async (id) => {
    const payload = {
      permit_id: permit_id,
      renewal_id: id,
      additional_instruction: formData.additional_instruction,
      request_type: "extension",
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.put(
        `${API_URL}/api/v2/fire_safety/approve`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Extension Permit Approved successfully.");
        await fetchData(page, itemsPerPage);
        setTimeout(() => {
          navigate(`/cold-work-permit?tab=Issued`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to renew permit.");
      }
    } catch (error) {
      console.error("Error renewing permit:", error);
      setSeverity("error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while renewing the permit.";
      showSnackbar(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleIssuerExtension = async (id) => {
    const payload = {
      permit_id: permit_id,
      renewal_id: id,
      additional_instruction: formData.additional_instruction,
      request_type: "extension",
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.put(
        `${API_URL}/api/v2/issuer/final_issue`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Extension Permit Approved successfully.");
        await fetchData(page, itemsPerPage);
        setTimeout(() => {
          navigate(`/cold-work-permit?tab=Issued`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to renew permit.");
      }
    } catch (error) {
      console.error("Error renewing permit:", error);
      setSeverity("error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while renewing the permit.";
      showSnackbar(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewGenratePermit = async (formId, work_permit_name) => {
    if (isExcavationPermitPdf(work_permit_name)) {
      return downloadExcavationPermitPdf(formId, { isSidebarExpanded });
    }
    let TemplateComponent;

    switch (work_permit_name?.toLowerCase()) {
      case "cold work":
        TemplateComponent = ColdWorkPermitTemplate;
        break;
      case "hot work":
        TemplateComponent = HotWorkPermitTemplate;
        break;
      case "confined space":
        TemplateComponent = ConfinedSpaceTemplate;
        break;
      default:
        console.error("Unknown permit type:", work_permit_name);
        return;
    }
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_permit_details`, {
        headers: { Authorization: authKey },
        params: { permit_id: formId },
      });

      if (response.status === 200) {
        const permitDetails = response.data;

        const tempDiv = document.createElement("div");
        document.body.appendChild(tempDiv);

        ReactDOM.render(
          <TemplateComponent
            permitDetails={permitDetails}
            isSidebarExpanded={isSidebarExpanded}
          />,
          tempDiv
        );

        const section1 = tempDiv.querySelector("#section1");
        const section2 = tempDiv.querySelector("#section2");

        if (!section1 || !section2) {
          console.error("PDF sections not found.");
          return;
        }

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = 210;
        const pageHeight = 297;
        const margin = 5;

        const options = {
          scale: 1.8,
          useCORS: true,
          backgroundColor: "white",
          windowWidth: 1550,
        };

        const canvas1 = await html2canvas(section1, options);
        const imgData1 = canvas1.toDataURL("image/jpeg", 0.9);

        const imgWidth1 = pageWidth - margin * 2;
        const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;

        const adjustedHeight1 =
          imgHeight1 > pageHeight - margin * 2
            ? pageHeight - margin * 2
            : imgHeight1;

        pdf.addImage(
          imgData1,
          "JPEG",
          margin,
          margin,
          imgWidth1,
          adjustedHeight1
        );

        const canvas2 = await html2canvas(section2, options);
        const imgData2 = canvas2.toDataURL("image/jpeg", 0.9);

        const imgWidth2 = pageWidth - margin * 2;
        const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;

        const adjustedHeight2 =
          imgHeight2 > pageHeight - margin * 2
            ? pageHeight - margin * 2
            : imgHeight2;

        pdf.addPage();
        pdf.addImage(
          imgData2,
          "JPEG",
          margin,
          margin,
          imgWidth2,
          adjustedHeight2
        );

        const fileSafePermitName = work_permit_name.replace(/\s+/g, "_");
        const fileName = `${fileSafePermitName}_Permit_${formId}.pdf`;
        pdf.save(fileName);

        ReactDOM.unmountComponentAtNode(tempDiv);
        document.body.removeChild(tempDiv);
      } else {
        console.error("Failed to fetch permit details:", response.statusText);
      }
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  function getStatusColor(status) {
    switch (status) {
      case "Pending":
        return "orange";
      case "Approved":
        return "green";
      case "In Review":
        return "blue";
      case "Pending Approval":
        return "purple";
      case "Extension Approved by Issuer":
        return "teal";
      case "Extension Approved by Safety":
        return "darkblue";
      default:
        return "black";
    }
  }

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          {isChecked ? (
            <div className="action-header">
              <div className="action-header-content">
                <div className="action-header-content-leftside"></div>
                <div className="action-header-content-rightside">
                  <button
                    className="action-header-close-button"
                    onClick={handleCloseButtonClick}
                  >
                    <IoCloseOutline className="action-header-close-icon" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="data-list-header">
              <div className="data-list-header-content">
                <div className="data-list-heading-content-left-side">
                  <Tooltip title="Back" arrow>
                    <IoMdArrowBack
                      className="back-company"
                      onClick={handleBack}
                    />
                  </Tooltip>
                  All Extension Permit
                </div>
                <div className="data-list-heading-content-right-side">
                  <Tooltip title="Refresh List" arrow>
                    <button className="refresh-button" onClick={handleRefresh}>
                      <TbRefresh className="refresh-icon" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : designations.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">SR. NO.</th>
                        <th>FROM DATE & TIME</th>
                        <th>TO DATE & TIME</th>
                        <th>RECEIVER NAME</th>
                        <th>STATUS</th>
                        <th>EXTENSION REASON</th>
                        <th>CREATED AT</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {designations.map((designation, index) => (
                        <tr key={designation.id} className="hoverable-row">
                          <td className="center-alignment">{index + 1}</td>
                          <td>
                            {formatDateTime(designation.date_from || "NA")}
                          </td>
                          <td>{formatDateTime(designation.date_to || "NA")}</td>
                          <td>{designation.receiver_name || "NA"}</td>
                          <td
                            style={{
                              color: getStatusColor(designation.status),
                              fontWeight: "bold",
                            }}
                          >
                            {designation.status || "NA"}
                          </td>
                          <td>{designation.extension_reason || "NA"}</td>
                          <td>
                            {designation.renewal_date
                              ? new Date(designation.renewal_date)
                                  .toUTCString()
                                  .split("GMT")[0]
                                  .trim() + " IST"
                              : "NA"}
                          </td>

                          <td>
                            <div className="new-permit">
                              {(designation.status === "Pending Approval" ||
                                designation.status === "Pending" ||
                                designation?.status ===
                                  "Extension Approved by Issuer" ||
                                designation?.status ===
                                  "Extension Approved by Safety") && (
                                <button
                                  className="new-button-download"
                                  onClick={() =>
                                    handleActionButton(designation.id)
                                  }
                                >
                                  Take Action
                                </button>
                              )}

                              {designation.status === "In Review" && (
                                <button
                                  className="new-button-download"
                                  onClick={() =>
                                    handleActionButton(designation.id)
                                  }
                                  disabled={
                                    designation.safety_officer_approval_status ===
                                    1
                                  }
                                >
                                  Take Action
                                </button>
                              )}
                            </div>

                            {isActionPopupOpen && (
                              <div className="reminder-popup-model">
                                <div className="reminder-popup-content">
                                  <div className="reminder-popup-model-header">
                                    <div className="reminder-popup-model-content-header">
                                      <div className="reminder-popup-model-content-header-left-part">
                                        Extension Permit Detail
                                      </div>
                                      <div className="reminder-popup-model-content-header-right-part">
                                        <button
                                          className="new-button-download"
                                          onClick={() =>
                                            handleViewGenratePermit(
                                              designation.permit_id,
                                              designation.work_permit_name
                                            )
                                          }
                                        >
                                          View Permit Request
                                        </button>
                                      </div>
                                    </div>
                                    <div className="popup-new-form">
                                      <div className="popup-form-detail">
                                        <div className="new-data-form">
                                          <table className="table multilevel-data">
                                            <thead>
                                              <tr>
                                                <th className="center-alignment">
                                                  SR. NO.
                                                </th>
                                                <th>RECEIVER NAME</th>
                                                <th>FROM DATE & TIME</th>
                                                <th>TO DATE & TIME</th>
                                                <th>STATUS</th>
                                                <th>EXTENSION REASON</th>
                                                <th>ADDITIONAL PRECAUTIONS</th>
                                              </tr>
                                            </thead>
                                            <tbody className="data-list-scroll-bodys">
                                              {actionDesignations && (
                                                <tr key={actionDesignations.id}>
                                                  <td className="center-alignment">
                                                    1
                                                  </td>
                                                  <td>
                                                    {actionDesignations.receiver_name ||
                                                      "NA"}
                                                  </td>

                                                  <td>
                                                    {formatDateTime(
                                                      actionDesignations.date_from ||
                                                        "NA"
                                                    )}
                                                  </td>
                                                  <td>
                                                    {formatDateTime(
                                                      actionDesignations.date_to ||
                                                        "NA"
                                                    )}
                                                  </td>
                                                  <td>
                                                    {actionDesignations.status ||
                                                      "NA"}
                                                  </td>
                                                  <td>
                                                    {actionDesignations.extension_reason ||
                                                      "NA"}
                                                  </td>
                                                  <td>
                                                    {actionDesignations.additional_instruction ||
                                                      "NA"}
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                        {(actionDesignations?.status ===
                                          "Pending" ||
                                          actionDesignations?.status ===
                                            "Extension Approved by Issuer") && (
                                          <form className="form-detail">
                                            <div className="new-data-form">
                                              <div className="form-group">
                                                <label htmlFor="additional_instruction">
                                                  Additional precautions if any,
                                                  Otherwise mention "NIL"
                                                </label>
                                                <div className="input-group">
                                                  <textarea
                                                    name="additional_instruction"
                                                    type="message"
                                                    rows={5}
                                                    cols={7}
                                                    value={
                                                      formData.additional_instruction
                                                    }
                                                    onChange={handleInputChange}
                                                    className="textarea"
                                                    placeholder="Enter additional instruction"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </form>
                                        )}
                                      </div>
                                    </div>
                                    <div className="footers">
                                      <div className="button-group-email">
                                        <div>
                                          <button
                                            className="data-form-cancel-button"
                                            onClick={handleClosepopup}
                                          >
                                            Cancel
                                          </button>

                                          {actionDesignations?.status ===
                                            "Pending" && (
                                            <button
                                              className="new-button-download approve_btn_clr"
                                              onClick={() =>
                                                handleExtensionReason(
                                                  actionDesignations.id
                                                )
                                              }
                                              disabled={isLoading}
                                              style={{ marginLeft: "1rem" }}

                                            >
                                              {isLoading
                                                ? "Approving..."
                                                : "Approve"}
                                            </button>
                                          )}

                                          {actionDesignations?.status ===
                                            "Extension Approved by Issuer" && (
                                            <button
                                              className="new-button-download approve_btn_clr"
                                              onClick={() =>
                                                handleFireAndSafetyExtension(
                                                  actionDesignations.id
                                                )
                                              }
                                              disabled={isLoading}
                                              style={{ marginLeft: "1rem" }}

                                            >
                                              {isLoading
                                                ? "Approving..."
                                                : "Approve"}
                                            </button>
                                          )}

                                          {actionDesignations?.status ===
                                            "Extension Approved by Safety" && (
                                            <button
                                              className="new-button-download approve_btn_clr"
                                              onClick={() =>
                                                handleIssuerExtension(
                                                  actionDesignations.id
                                                )
                                              }
                                              disabled={isLoading}
                                              style={{ marginLeft: "1rem" }}
                                            >
                                              {isLoading
                                                ? "Approving..."
                                                : "Approve"}
                                            </button>
                                          )}

                                          {actionDesignations?.status ===
                                            "Pending Approval" && (
                                            <button
                                              className="new-button-download"
                                              onClick={() =>
                                                handleExtensionIssuClick(
                                                  actionDesignations.id
                                                )
                                              }
                                              disabled={isLoading}
                                              style={{ marginLeft: "1rem" }}
                                            >
                                              {isLoading ? "Issuing..." : "Issue"}
                                            </button>
                                          )}

                                          {(actionDesignations?.status ===
                                            "In Review" ||
                                            actionDesignations?.status ===
                                              "Extension Approved by Issuer" ||
                                            actionDesignations?.status ===
                                              "Extension Approved by Safety" ||
                                            actionDesignations?.status ===
                                              "Pending") && (
                                            <button
                                              className="data-form-reject-button"
                                              onClick={() =>
                                                handleRejectClick(
                                                  actionDesignations.id
                                                )
                                              }
                                              style={{ marginLeft: "1rem" }}
                                            >
                                              Reject
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {isPopupOpen && (
                              <div className="permit-popup-model">
                                <div className="form-permit-popup-content">
                                  <div className="reminder-popup-model-header">
                                    <div className="reminder-popup-model-content-header">
                                      <div className="reminder-popup-model-content-header-left-part">
                                        Reject Permit
                                      </div>
                                      <div className="reminder-popup-model-content-header-right-part"></div>
                                    </div>
                                    <div className="permit-popup-new-form">
                                      <form className="form-permit-popup-detail">
                                        <div className="new-data-form">
                                          <div className="new-form-group email-filed">
                                            <label htmlFor="reason">
                                              Reason for rejection{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group">
                                              <textarea
                                                id="reason"
                                                name="reason"
                                                placeholder="Enter reason"
                                                value={reason}
                                                onChange={handleReasonChange}
                                                rows="4"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                    <div className="footers">
                                      <div className="form-button-group">
                                        <div>
                                          <button
                                            className="form-reject-button"
                                            type="button"
                                            onClick={() =>
                                              handleSaveRejectClick(renewalId)
                                            }
                                            disabled={isLoading}
                                          >
                                            {isLoading ? "Rejecting..." : "Reject"}
                                          </button>

                                          <button
                                            className="person-user-cancel-button"
                                            onClick={closePopup}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                        <div></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Data Found</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default PermitExtensionRequestView;
